export default __webpack_public_path__ + "static/media/7.0fc55608.png";